import React from 'react'
import { Tabs, Tab, Row, Col } from '@themesberg/react-bootstrap'
import Overview from './components/Overview'
import Permissions from './components/Permissions'
import useAdminDetails from './hooks/useAdminDetails'
import Hierarchy from '../../../components/Hierarchy'
import Preloader from '../../../components/Preloader'
import PageBackButton from '../../../components/PageBackButton'


const AdminDetails = () => {
  const {
    setSelectedTab,
    selectedTab,
    adminDetails,
    loading
  } = useAdminDetails()

  return (
    <>
      {loading && <Preloader />}
      <>
      <div className='section-header-wrap mt-n3 mx-n3'>
        <Row>
          <Col className='backbtn'>
           {/* <div className='backbtn'> */}
                       <PageBackButton />
            <h3 className='mb-0'>{adminDetails?.AdminRole?.name}:&nbsp; </h3>
            <h3 className='mb-0'>
              <div
                style={{
                  whitespace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden'
                }}
              >
                {adminDetails &&
                  `${adminDetails?.firstName} ${adminDetails?.lastName}`}
              </div>
            </h3>
          </Col>

          {/* <Col xs={1} className='w-auto'>
          <div className='text-right'>
            <Button
              className='d-flex mb-2'
              variant='outline-warning'
              onClick={() =>
                navigate(
              `/admin/admins/edit/${adminId}`
                )}
            >
              Edit
            </Button>
          </div>
        </Col> */}
        </Row>
        </div>
        <Tabs
          activeKey={selectedTab}
          onSelect={(tab) => setSelectedTab(tab)}
          className='nav-light'
        >
          <Tab eventKey='overview' title='Overviews'>
            <div className='mt-5 FormsBg'>
              <Row className='mt-3 '>
                <Overview adminDetails={adminDetails} />
              </Row>
            </div>
          </Tab>

          {/* <Tab eventKey='wallet' title='Wallet'>
          <div className='mt-5'>
            <Row className='mt-3 '>
              <AdminWallet adminDetails={adminDetails} />
            </Row>
          </div>
        </Tab> */}

          <Tab eventKey='permissions' title='Permissions'>
            <div className='mt-5'>
              <Row className='mt-3 d-flex text-left'>
                <Permissions adminDetails={adminDetails} />
              </Row>
            </div>
          </Tab>

          {/* <Tab eventKey='usersTree' title='Tree'>
            <div className='mt-5'>
              <Row className='mt-3 d-flex flex-row-reverse text-right'>
                {adminDetails && adminDetails?.superAdminUserId && (
                  <Hierarchy
                    isTenant={false}
                    adminDetails={{
                      name: `${adminDetails?.firstName} ${adminDetails?.lastName}`,
                      id: adminDetails?.superAdminUserId,
                      children: [],
                      isInitial: true,
                      data: { superRoleId: adminDetails?.superRoleId }
                    }}
                  />
                )}
              </Row>
            </div>
          </Tab> */}

          {/* <Tab eventKey='subAdmins' title='SubAdmins'>
          <div className='mt-5'>
            <Row className='mt-3 d-flex flex-row-reverse text-right'>
              <SubAdmins superAdminId={adminId} />
            </Row>
          </div>
        </Tab> */}
        </Tabs>
      </>
    </>
  )
}

export default AdminDetails
